import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { $postRequestStore } from '@lib/store';
import { cn, LsbUtils } from '@shared/utils';
import type { LifestyleCategory } from '@shared/api';
import { BaseInput, Button, Spinner, Textarea } from '@shared/widgets';

interface FormData {
  type: string;
  description: string;
}
const DEFAULT_VALUES: FormData = { type: '', description: '' };

interface RequestFormProps {
  className?: string;
  category: LifestyleCategory;
}

export const RequestForm = (props: RequestFormProps) => {
  const { control, formState, handleSubmit, reset } = useForm<FormData>({ defaultValues: { ...DEFAULT_VALUES, type: props.category.title } });

  const { t } = useTranslation('concierge');

  const submitHandler = async (data: FormData) => {
    await $postRequestStore.events.postRequest({ type: LsbUtils.getLsbRequestType(props.category.type), description: data.description });
    reset({ ...DEFAULT_VALUES, type: props.category.title });
  };

  return (
    <form className={cn('flex flex-col gap-4', props.className)} noValidate onSubmit={handleSubmit(submitHandler)}>
      <Spinner show={formState.isSubmitting} position />
      <Controller
        name='type'
        control={control}
        rules={{ required: t('errors.form.required', { ns: 'common' }) }}
        render={({ field, fieldState: { error } }) => (
          <BaseInput
            {...field}
            inputClassName='opacity-100'
            label={t('request.labels.subject')}
            placeholder={t('request.placeholders.subject')}
            required
            readOnly
            error={error?.message}
          />
        )}
      />
      <Controller
        name='description'
        control={control}
        rules={{ required: t('errors.form.required', { ns: 'common' }) }}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Textarea
            textareaClassName='min-h-32'
            label={t('request.labels.message')}
            placeholder={t('request.placeholders.message')}
            required
            error={error?.message}
            value={value}
            onChange={onChange}
          />
        )}
      />
      <Button fullWidth color='primary' type='submit' disabled={formState.isSubmitting}>
        {t('buttons.send', { ns: 'common' })}
      </Button>
    </form>
  );
};
